import React from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import HealthAndSafetyRoundedIcon from "@mui/icons-material/HealthAndSafetyRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import aboutImage from "../../assets/img/header/about-img.png";

const GOLD = "#b98a52";
const DARK = "#12100e";
const CREAM = "#f7f1e7";

const pillars = [
  {
    icon: <WorkspacePremiumRoundedIcon />,
    title: "Nuestra misión",
    text: "Ofrecer servicios de belleza y cuidado personal de alta calidad, respetando la identidad y el estilo de cada cliente.",
  },
  {
    icon: <VisibilityRoundedIcon />,
    title: "Nuestra visión",
    text: "Ser un estudio reconocido por la excelencia, la confianza y una experiencia que las personas quieran volver a elegir.",
  },
  {
    icon: <FavoriteBorderRoundedIcon />,
    title: "Nuestros valores",
    text: "Profesionalismo, higiene, respeto, compromiso y pasión por cada detalle del servicio.",
  },
];

const strengths = [
  {
    icon: <GroupsRoundedIcon />,
    title: "Equipo especializado",
    text: "Profesionales de peluquería, barbería, pestañas y estética integral.",
  },
  {
    icon: <AutoAwesomeIcon />,
    title: "Atención personalizada",
    text: "Escuchamos lo que buscás y adaptamos cada servicio a vos.",
  },
  {
    icon: <HealthAndSafetyRoundedIcon />,
    title: "Cuidado y confianza",
    text: "Trabajamos con higiene, dedicación y productos seleccionados.",
  },
];

const About = () => {
  return (
    <Box sx={{ bgcolor: "#fff", color: DARK }}>
      <Navbar />

      <Box
        component="section"
        sx={{
          position: "relative",
          overflow: "hidden",
          bgcolor: DARK,
          color: "#fff",
          pt: { xs: 14, sm: 16, md: 18 },
          pb: { xs: 9, md: 12 },
          backgroundImage:
            "radial-gradient(circle at 85% 20%, rgba(185,138,82,.28), transparent 30%), radial-gradient(circle at 10% 90%, rgba(185,138,82,.14), transparent 28%)",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: 280,
            height: 280,
            border: "1px solid rgba(255,255,255,.08)",
            borderRadius: "50%",
            right: { xs: -190, md: -70 },
            bottom: -150,
          }}
        />
        <Container maxWidth="lg" sx={{ position: "relative" }}>
          <Grid container spacing={{ xs: 5, md: 8 }} alignItems="center">
            <Grid item xs={12} md={7}>
              <Chip
                icon={<AutoAwesomeIcon sx={{ color: "#e2bd8d !important" }} />}
                label="BELLEZA CON IDENTIDAD"
                sx={{
                  mb: 3,
                  color: "#f2d7b6",
                  bgcolor: "rgba(185,138,82,.14)",
                  border: "1px solid rgba(226,189,141,.28)",
                  fontWeight: 800,
                  letterSpacing: 1.2,
                }}
              />
              <Typography
                component="h1"
                sx={{
                  maxWidth: 760,
                  fontSize: { xs: "2.65rem", sm: "3.7rem", md: "4.6rem" },
                  lineHeight: 1.02,
                  letterSpacing: "-.045em",
                  fontWeight: 800,
                }}
              >
                Tu estilo, cuidado con intención.
              </Typography>
              <Typography
                sx={{
                  maxWidth: 680,
                  mt: 3,
                  color: "rgba(255,255,255,.72)",
                  fontSize: { xs: 17, md: 20 },
                  lineHeight: 1.7,
                }}
              >
                En Estudio Isaac reunimos peluquería, barbería y estética en un
                espacio pensado para que te sientas cómodo, escuchado y seguro
                con el resultado.
              </Typography>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} mt={4}>
                <Button
                  component={Link}
                  to="/"
                  variant="contained"
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    bgcolor: GOLD,
                    color: "#fff",
                    px: 3,
                    py: 1.35,
                    borderRadius: 99,
                    fontWeight: 800,
                    textTransform: "none",
                    boxShadow: "0 12px 30px rgba(185,138,82,.28)",
                    "&:hover": { bgcolor: "#a67945" },
                  }}
                >
                  Explorar servicios
                </Button>
                <Button
                  component={Link}
                  to="/contactanos"
                  variant="outlined"
                  sx={{
                    color: "#fff",
                    borderColor: "rgba(255,255,255,.35)",
                    px: 3,
                    py: 1.35,
                    borderRadius: 99,
                    fontWeight: 700,
                    textTransform: "none",
                    "&:hover": { borderColor: "#fff", bgcolor: "rgba(255,255,255,.06)" },
                  }}
                >
                  Contactarnos
                </Button>
              </Stack>
            </Grid>

            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  ml: { md: "auto" },
                  maxWidth: 430,
                  borderLeft: `2px solid ${GOLD}`,
                  pl: 3,
                  py: 1,
                }}
              >
                <Typography sx={{ color: "#e2bd8d", fontWeight: 800, mb: 1 }}>
                  ESTUDIO ISAAC
                </Typography>
                <Typography sx={{ color: "rgba(255,255,255,.68)", lineHeight: 1.8 }}>
                  Una experiencia integral donde la técnica, el cuidado y la
                  atención humana se encuentran en cada visita.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box component="section" sx={{ bgcolor: CREAM, py: { xs: 3, md: 4 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            {strengths.map((item) => (
              <Grid item xs={12} md={4} key={item.title}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, p: 1.5 }}>
                  <Avatar
                    sx={{ bgcolor: "#fff", color: GOLD, width: 46, height: 46, boxShadow: "0 8px 20px rgba(70,48,25,.08)" }}
                  >
                    {item.icon}
                  </Avatar>
                  <Box>
                    <Typography fontWeight={800}>{item.title}</Typography>
                    <Typography sx={{ color: "#74695e", fontSize: 14, lineHeight: 1.6, mt: 0.4 }}>
                      {item.text}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box component="section" sx={{ py: { xs: 9, md: 14 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 6, md: 9 }} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ position: "relative", pr: { md: 2 }, pb: { xs: 2, md: 3 } }}>
                <Box
                  component="img"
                  src={aboutImage}
                  alt="Interior de Estudio Isaac"
                  sx={{
                    display: "block",
                    width: "100%",
                    minHeight: { xs: 300, sm: 430 },
                    maxHeight: 540,
                    objectFit: "cover",
                    borderRadius: { xs: 4, md: 6 },
                    filter: "saturate(.82) contrast(1.04)",
                    boxShadow: "0 28px 70px rgba(41,27,14,.18)",
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    right: { xs: 12, md: -10 },
                    bottom: 0,
                    maxWidth: 230,
                    bgcolor: "#fff",
                    borderRadius: 3,
                    p: 2.2,
                    boxShadow: "0 18px 46px rgba(30,20,12,.16)",
                    border: "1px solid #eee4d5",
                  }}
                >
                  <Typography sx={{ color: GOLD, fontSize: 12, fontWeight: 900, letterSpacing: 1 }}>
                    CADA DETALLE CUENTA
                  </Typography>
                  <Typography sx={{ mt: 0.7, fontSize: 14, lineHeight: 1.55, fontWeight: 700 }}>
                    Técnica profesional y una atención verdaderamente cercana.
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography sx={{ color: GOLD, fontWeight: 900, letterSpacing: 1.5, fontSize: 12 }}>
                QUIÉNES SOMOS
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  mt: 1.5,
                  fontSize: { xs: "2.25rem", md: "3.25rem" },
                  lineHeight: 1.12,
                  letterSpacing: "-.035em",
                  fontWeight: 800,
                }}
              >
                Belleza, estilo y profesionalismo en un mismo lugar.
              </Typography>
              <Typography sx={{ color: "#6e655d", lineHeight: 1.8, fontSize: 16, mt: 3 }}>
                Somos un equipo de profesionales especializados que trabaja con
                técnicas actuales, productos de calidad y una mirada personalizada
                sobre cada servicio.
              </Typography>
              <Typography sx={{ color: "#6e655d", lineHeight: 1.8, fontSize: 16, mt: 2 }}>
                Nuestro propósito es que cada visita sea clara, cómoda y cuidada:
                desde la elección del servicio hasta el momento en que salís del estudio.
              </Typography>

              <Stack spacing={1.5} mt={3.5}>
                {["Asesoramiento según tu estilo", "Servicios integrales en un solo espacio", "Cuidado profesional en cada etapa"].map((text) => (
                  <Box key={text} sx={{ display: "flex", alignItems: "center", gap: 1.3 }}>
                    <CheckCircleRoundedIcon sx={{ color: GOLD, fontSize: 21 }} />
                    <Typography fontWeight={700}>{text}</Typography>
                  </Box>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box component="section" sx={{ bgcolor: "#faf8f4", py: { xs: 9, md: 12 } }}>
        <Container maxWidth="lg">
          <Box textAlign="center" maxWidth={720} mx="auto" mb={{ xs: 5, md: 7 }}>
            <Typography sx={{ color: GOLD, fontWeight: 900, letterSpacing: 1.5, fontSize: 12 }}>
              LO QUE NOS GUÍA
            </Typography>
            <Typography
              variant="h2"
              sx={{ mt: 1.5, fontSize: { xs: "2.2rem", md: "3rem" }, fontWeight: 800, letterSpacing: "-.03em" }}
            >
              Una forma de trabajar basada en la confianza.
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {pillars.map((pillar, index) => (
              <Grid item xs={12} md={4} key={pillar.title}>
                <Card
                  elevation={0}
                  sx={{
                    height: "100%",
                    borderRadius: 4,
                    border: "1px solid #e9e1d5",
                    bgcolor: index === 1 ? DARK : "#fff",
                    color: index === 1 ? "#fff" : DARK,
                    transition: "transform .25s ease, box-shadow .25s ease",
                    "&:hover": { transform: "translateY(-6px)", boxShadow: "0 22px 50px rgba(42,29,18,.10)" },
                  }}
                >
                  <CardContent sx={{ p: { xs: 3, md: 4 }, "&:last-child": { pb: { xs: 3, md: 4 } } }}>
                    <Avatar sx={{ bgcolor: index === 1 ? GOLD : CREAM, color: index === 1 ? "#fff" : GOLD, width: 52, height: 52, mb: 3 }}>
                      {pillar.icon}
                    </Avatar>
                    <Typography variant="h5" fontWeight={800}>{pillar.title}</Typography>
                    <Typography sx={{ mt: 1.5, lineHeight: 1.75, color: index === 1 ? "rgba(255,255,255,.68)" : "#71675e" }}>
                      {pillar.text}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box component="section" sx={{ py: { xs: 8, md: 11 }, bgcolor: "#fff" }}>
        <Container maxWidth="lg">
          <Box
            sx={{
              overflow: "hidden",
              borderRadius: { xs: 4, md: 6 },
              bgcolor: DARK,
              color: "#fff",
              px: { xs: 3, sm: 5, md: 8 },
              py: { xs: 5, md: 7 },
              backgroundImage: "linear-gradient(120deg, #12100e 30%, #2b2118 100%)",
            }}
          >
            <Box sx={{ maxWidth: 760 }}>
              <Typography sx={{ color: "#e2bd8d", fontWeight: 900, letterSpacing: 1.3, fontSize: 12 }}>
                TU PRÓXIMA EXPERIENCIA
              </Typography>
              <Typography sx={{ mt: 1.5, fontSize: { xs: "2rem", md: "2.75rem" }, lineHeight: 1.15, fontWeight: 800 }}>
                Encontrá el servicio que mejor acompaña tu estilo.
              </Typography>
              <Typography sx={{ mt: 2, color: "rgba(255,255,255,.68)", lineHeight: 1.7, maxWidth: 630 }}>
                Conocé nuestras opciones, elegí a tu profesional y reservá el horario que más te convenga.
              </Typography>
              <Button
                component={Link}
                to="/"
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                sx={{ mt: 3.5, bgcolor: GOLD, borderRadius: 99, px: 3, py: 1.3, fontWeight: 800, textTransform: "none", "&:hover": { bgcolor: "#a67945" } }}
              >
                Ver servicios y reservar
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>

      <Footer />
    </Box>
  );
};

export default About;
